module.exports = __webpack_public_path__ + "static/faqsexample-8026118e4d7d584c6994ce2afb55c5fb.svg";